import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import i18n from "./i18n/i18n";
import './index.css';
import { I18nextProvider } from "react-i18next";
import RouteInit from './routes/RouteInit';
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { store } from './redux/Store';
import { Provider } from 'react-redux';
import TimeSyncChecker from './component/TimeSyncChecker';
const persistor = persistStore(store);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <I18nextProvider i18n={i18n}>
      <TimeSyncChecker>
      <RouteInit/>
      </TimeSyncChecker>
    </I18nextProvider>
    </PersistGate>
    </Provider>
    </BrowserRouter>
     </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
